export default __webpack_public_path__ + "static/media/Proverp_Info1.97c253d7.png";